import React from "react";
import { Link } from "react-router-dom";
import data from "../data/contact.json";
import { contactFormAction, socialLink } from "../global";
import Swal from 'sweetalert2'

function Submit(e) {
  e.preventDefault();


  const formEle = document.querySelector("form");
  const formDatab = new FormData(formEle);
  fetch(
    "https://script.google.com/macros/s/AKfycbxSeftKDGwIGE8k37QGPrv0dpeUb5Ymjjf--eYlRy1JTdRS-Po0sKLJDwsknOShqO-t/exec",
    {
      method: "POST",
      body: formDatab
    }
  )
    .then((res) => res.json())
    .then((data) => {
      console.log(data);

    })
    .catch((error) => {
      console.log(error);
    });
  document.getElementById('contact-name').value = '';
  document.getElementById('contact-email').value = '';
  document.getElementById('contact-subject').value = '';
  document.getElementById('contact-message').value = '';
}

const handleSuccessclick = () => {
  Swal.fire('Success!', 'We connect you soon.', 'success');

}

const Contact = ({ isBg }) => {
  const { contact } = data;
  return (
    // <!-- ========== Contact section start ========== -->
    <section
      id="contact"
      className={`p-80px-tb ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{contact.subtitle}</span>
              <h2 className="display-6">{contact.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* <!--  contact form area start --> */}
          <div
            className="col-lg-8 col-md-6 col-sm-12 m-25px-b"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="contact-form-box">
              <form className="form" onSubmit={(e) => Submit(e)}>



                <div className="mb13">
                  <input
                    name="Name"
                    className="contact-name"
                    id="contact-name"
                    type="text"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="mb13">
                  <input
                    name="Email"
                    className="contact-email"
                    id="contact-email"
                    type="email"
                    placeholder="Your Email"
                    required
                  />
                </div>
                <div className="mb13">
                  <input
                    name="Subject"
                    className="contact-subject"
                    id="contact-subject"
                    type="text"
                    placeholder="Subject"
                    required
                  />
                </div>
                <div className="mb30">
                  <textarea
                    name="Message"
                    className="contact-message"
                    id="contact-message"
                    placeholder="Your Message"
                    required
                  ></textarea>
                </div>
                <button onClick={handleSuccessclick}
                  type="submit" name="Name"
                  className="button button__primary align-items-center"
                >
                  <span>{contact.btnText}</span>
                </button>
              </form>
            </div>
          </div>
          {/* <!--  contact form area end --> */}
          {/* <!-- contact information start --> */}
          <div
            className="col-lg-4 col-md-6 col-sm-12 m-25px-b"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="contact__address p-30px">
              <ul className="contact__address__content">
                <li>
                  <span>{contact.address}</span>
                  {contact.addressText1}
                  <br />
                  {contact.addressText2}
                </li>
                <li>
                  <span>{contact.phone}</span>
                  <a href="tel:1124447900">{contact.number}</a>
                </li>
                <li>
                  <span>{contact.email}</span>
                  <Link to="/#">{contact.emailText}</Link>
                </li>
              </ul>
              <h4>{contact.socialTitle}</h4>
              <ul className="social-icon mt-3">
                {socialLink.facebook === "" ? (
                  ""
                ) : (
                  <li>
                    <a href={socialLink.facebook} target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/facebook.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                )}
                {socialLink.twitter === "" ? (
                  ""
                ) : (
                  <li>
                    <a href="https://cuo.irins.org/profile/61438/" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/CuO.png"
                        alt="CUO"
                        width="100"
                        height="100"
                      />
                    </a>
                  </li>
                )}
                {socialLink.linkedin === "" ? (
                  ""
                ) : (
                  <li>
                    <a href="https://www.efsle.org/sanjeet-kumar-das/" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/eflse.png"
                        alt="eflse"
                        width="100"
                        height="100"
                      />
                    </a>
                  </li>
                )}
                {socialLink.youtube === "" ? (
                  ""
                ) : (
                  <li>
                    <a href="https://vidwan.inflibnet.ac.in/profile/61438/" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/research.png"
                        alt="sanjeet kumar das"
                        width="100"
                        height="100"
                      />
                    </a>
                  </li>
                )}



              </ul>
            </div>
          </div>
          {/* <!-- contact information end --> */}
        </div>
      </div>
    </section>
    // <!-- ========== Contact section end ========== -->
  );
};

export default Contact;
